module.exports = __webpack_public_path__ + "static/media/gasFill.7ee000cd.svg";